export const ONBOARDING_DISPLAY_LIMIT = 3;
